import { sortBy } from "lodash";

import { CustomerStoriesGridItemProps } from "./customer-stories-grid-item";

export enum orderByType {
  NewerToOlder = "newer_to_older",
  Alphabetical = "alphabetical",
  AlphabeticalInverted = "alphabetical_inverted",
}

export const sortStories = (
  stories: Omit<CustomerStoriesGridItemProps, "labels">[],
  orderBy: orderByType
) => {
  switch (orderBy) {
    case orderByType.Alphabetical:
      return sortBy(stories, (story) => story.name?.toLowerCase());
    case orderByType.AlphabeticalInverted:
      return sortBy(stories, (story) => story.name?.toLowerCase()).reverse();
    default:
      return sortBy(stories, (story) => story.updatedAt);
  }
};
